// Firebase web config for Simam 3D Studio.
//
// To enable one-click publishing:
//   1. Firebase console → Project settings → General → "Your apps" → Web app
//      → "SDK setup and configuration" → copy the config values below.
//   2. Build → Storage → enable Cloud Storage on the `sim-editor` project.
//   3. (Recommended) set Storage rules so published scenes are publicly readable,
//      e.g. allow read on `experiences/**`. See docs/firebase-storage.rules.
//
// Until apiKey + storageBucket are filled in, the Publish dialog detects this and
// shows a clear "not configured" message instead of failing at upload time.
const firebaseConfig = {
  apiKey: "AIzaSyCs8kCMJDMSAQV1Li-4aRK6nOfnXvrxu2w",
  authDomain: "sim-editor.firebaseapp.com",
  databaseURL: "https://sim-editor-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "sim-editor",
  storageBucket: "sim-editor.firebasestorage.app",
  messagingSenderId: "944773108213",
  appId: "1:944773108213:web:eb3a3276761d4477c490bc",
  measurementId: "G-KSFR69DYGL"
};

// folder (within the storage bucket) that published experiences are written to
const storagePrefix = 'experiences';

// reCAPTCHA v3 *site key* for Firebase App Check (this value is publishable — it is
// NOT a secret). When set, the app attaches an App Check token to every Storage
// upload so the open `write` rule on `experiences/**` can only be exercised by this
// app, not by anyone who scrapes the (intentionally public) viewer URLs.
//
// To enable:
//   1. Firebase console → Build → App Check → Apps → register the web app with the
//      reCAPTCHA v3 provider; copy the site key here.
//   2. Deploy this build (so live uploads carry an App Check token).
//   3. App Check → APIs → Cloud Storage → set enforcement to "Enforced".
//      (Do this LAST — enforcing before step 2 ships would break uploads.)
//   4. For local testing, run once, copy the debug token logged to the console, and
//      register it under App Check → Apps → Manage debug tokens.
const appCheckSiteKey = '';

// Studio (studio.simamdigital.com) is a SEPARATE Firebase project
// (sim-4d-viewer-app), not this one. This editor cannot write to its
// Firestore/Storage directly — those are locked to server-only writes (see
// that repo's firestore.rules/storage.rules). Publishing there goes through
// a Cloud Function (functions/src/index.ts in the studio repo) instead.
//
// To enable "Publish to Studio":
//   1. Deploy the `publishScene` function in the studio repo (needs the
//      project on the Blaze plan): `firebase deploy --only functions`.
//   2. Set its secret once: `firebase functions:secrets:set PUBLISH_TOKEN`
//      (pick any long random string).
//   3. Put that SAME string in `studioPublishToken` below, and the deployed
//      function's URL (shown after deploy, or via `firebase functions:list`)
//      in `studioPublishFunctionUrl`.
// Note: since this is a browser app, `studioPublishToken` is visible to
// anyone who reads the bundle — it deters casual abuse, not a determined
// attacker. Firebase App Check on the function would be the stronger fix.
const studioPublishFunctionUrl = '';
const studioPublishToken = '';

const isFirebaseConfigured = () => Boolean(firebaseConfig.apiKey && firebaseConfig.storageBucket);
const isStudioPublishConfigured = () => Boolean(studioPublishFunctionUrl && studioPublishToken);

export {
    firebaseConfig,
    storagePrefix,
    appCheckSiteKey,
    studioPublishFunctionUrl,
    studioPublishToken,
    isFirebaseConfigured,
    isStudioPublishConfigured
};
